import script from "./RecipeGenerator.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeGenerator.vue?vue&type=script&setup=true&lang=js"

import "./RecipeGenerator.vue?vue&type=style&index=0&id=3f97487e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2503735441/src/recipe-ai-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f97487e"]])

export default __exports__